import { lazy } from 'react';
import { authRoles } from 'app/auth';

const DataAppConfig = {
	settings: {
		layout: {}
	},
	auth: authRoles.admin,
	routes: [
		{
			path: '/apps/service-center/:dataID',
			component: lazy(() => import('./single/Data'))
		},
		{
			path: '/apps/service-center',
			component: lazy(() => import('./list/Datas'))
		}
	]
};

export default DataAppConfig;
